const PATH = 'profile';

export { PATH };
export default {};
